import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MatNativeDateModule } from '@angular/material/core';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChartModule } from 'angular-highcharts';


import { FormsModule }   from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { AppRoutingModule } from './app-routing.module';
import { AnalystModule } from './analyst/analyst.module';


import { AppComponent } from './app.component';

import { TwoDigitDecimaNumberDirectiveDirective } from './two-digit-decima-number-directive.directive'; 

import { LoginComponent } from './login/login.component';


import { FileUploadComponent } from './file-upload/file-upload.component';
import { AnalystComponent } from './analyst/analyst.component';

import { ViewFileComponent } from './view-file/view-file.component';

import * as $ from 'jquery';

//import { WorksheetComponent } from './worksheet/worksheet.component';
//import { WorksheetModule } from './worksheet/worksheet.module';
//import { WjGridModule, WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { ForgotpswComponent } from './forgotpsw/forgotpsw.component';
import { ConsoleReportComponent } from './console-report/console-report.component';
import { AdminComponent } from './admin/admin.component';
import { UserListComponent } from './user-list/user-list.component';
import { AddUserComponent } from './add-user/add-user.component';
import { AddCompanyComponent } from './add-company/add-company.component';
import { ListCompanyComponent } from './list-company/list-company.component';
import { FiledetailsComponent } from './filedetails/filedetails.component';
import { PendreqComponent } from './pendreq/pendreq.component';
import { FileauditComponent } from './fileaudit/fileaudit.component';
import { FileauditdetailsComponent } from './fileauditdetails/fileauditdetails.component';
import { AnalystDashComponent } from './analyst-dash/analyst-dash.component';
import { AdminDashComponent } from './admin-dash/admin-dash.component';
import { CeoComponent } from './ceo/ceo.component';
import { CeoDashComponent } from './ceo-dash/ceo-dash.component';
import { HelpDocComponent } from './help-doc/help-doc.component';
import { AdminfileComponent } from './adminfile/adminfile.component';
import { AdminFileViewComponent } from './admin-file-view/admin-file-view.component';
import { DataLockConfigComponent } from './data-lock-config/data-lock-config.component';
import { LoginAuditComponent } from './login-audit/login-audit.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { UserAuditComponent } from './user-audit/user-audit.component';
import { ConsoleViewComponent } from './console-view/console-view.component';
import { ChangePswComponent } from './change-psw/change-psw.component';
import { CompanyAuditComponent } from './company-audit/company-audit.component';
import { DelReqComponent } from './del-req/del-req.component';
import { QueryReportComponent } from './query-report/query-report.component';
import { QreportViewComponent } from './qreport-view/qreport-view.component';
import { PenreqAuditComponent } from './penreq-audit/penreq-audit.component';
import { UnlockSettingsComponent } from './unlock-settings/unlock-settings.component';
import { UnformatUploadComponent } from './unformat-upload/unformat-upload.component';
import { UnformatListComponent } from './unformat-list/unformat-list.component';
import { UnformatAuditComponent } from './unformat-audit/unformat-audit.component';
import { AdminConsoleComponent } from './admin-console/admin-console.component';
import { AdminConsoleViewComponent } from './admin-console-view/admin-console-view.component';
import { AdminQreportComponent } from './admin-qreport/admin-qreport.component';
import { AdminQrviewComponent } from './admin-qrview/admin-qrview.component';
import { EmailConfigComponent } from './email-config/email-config.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminPdApproveComponent } from './admin-pd-approve/admin-pd-approve.component';
import { AnalystHelpComponent } from './analyst-help/analyst-help.component';
import { FlashUploadComponent } from './flash-upload/flash-upload.component';
import { FlashViewComponent } from './flash-view/flash-view.component';
import { FlashReportComponent } from './flash-report/flash-report.component';
import { FlashReportViewComponent } from './flash-report-view/flash-report-view.component';
import { FileMatrixComponent } from './file-matrix/file-matrix.component';
import { ComplianceComponent } from './compliance/compliance.component';
import { LandingPageComponent } from './landing-page/landing-page.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotpswComponent,
    FileUploadComponent,
    AnalystComponent,
    ViewFileComponent,
    ConsoleReportComponent,
    AdminComponent,
    UserListComponent,
    AddUserComponent,
    AddCompanyComponent,
    ListCompanyComponent,
    FiledetailsComponent,
    PendreqComponent,
    FileauditComponent,
    FileauditdetailsComponent,
    AnalystDashComponent,
    AdminDashComponent,
    CeoComponent,
    CeoDashComponent,
    HelpDocComponent,
    AdminfileComponent,
    AdminFileViewComponent,
    DataLockConfigComponent,
    LoginAuditComponent,
    EditUserComponent,
    UserAuditComponent,
    ConsoleViewComponent,
    ChangePswComponent,
    CompanyAuditComponent,
    DelReqComponent,
    QueryReportComponent,
    QreportViewComponent,
    PenreqAuditComponent,
    UnlockSettingsComponent,
    UnformatUploadComponent,
    UnformatListComponent,
    UnformatAuditComponent,
    AdminConsoleComponent,
    AdminConsoleViewComponent,
    AdminQreportComponent,
    AdminQrviewComponent,
    EmailConfigComponent,
    DashboardComponent,
    AdminPdApproveComponent,
    AnalystHelpComponent,
    FlashUploadComponent,
    TwoDigitDecimaNumberDirectiveDirective,
    FlashViewComponent,
    FlashReportComponent,
    FlashReportViewComponent,
    FileMatrixComponent,
    ComplianceComponent,
    LandingPageComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    //WjGridModule,
    MatNativeDateModule,
    AnalystModule,
    HighchartsChartModule,
    ChartModule
    //Jquery
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
/*platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));*/

